(function() {
  function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
  }
  var $5f3f247996b86434$exports = {};
  "use strict";
  function $5f3f247996b86434$var$t(t) {
    return t ? t.trim().replace(/\s+/g, " ") : "";
  }
  function $5f3f247996b86434$var$e(t) {
    t.dataset.originaltext || (t.dataset.originaltext = t.innerHTML);
  }
  function $5f3f247996b86434$var$n(t, e) {
    e.split(" ").map(function(e) {
      return t.classList.add(e);
    });
  }
  function $5f3f247996b86434$var$a(t, e) {
    for (var n = 0, a = Object.entries(e); n < a.length; n++) {
      var r = a[n], o = r[0], i = r[1];
      t.style[o] = i;
    }
  }
  function $5f3f247996b86434$var$r(t) {
    for (var e, n = [], a = document.createTreeWalker(t, NodeFilter.SHOW_TEXT, null); e = a.nextNode(); ) n.push(e);
    return n;
  }
  function $5f3f247996b86434$var$o(o, i, l, c, s) {
    $5f3f247996b86434$var$e(o), $5f3f247996b86434$var$r(o).forEach(function(e) {
      !function(e, r, o, i, l, c) {
        var s, d, u = r.dataset.originaltext, p = e.textContent || "";
        u && (p = u);
        var v = document.createRange(), f = [], h = [];
        e.textContent = $5f3f247996b86434$var$t(p);
        for (var m = (null === (s = e.textContent) || void 0 === s ? void 0 : s.length) || 0, C = 0; C < m; C++) {
          v.setStart(e, 0), v.setEnd(e, C + 1);
          var x = v.getClientRects().length - 1;
          f[x] || (f[x] = []), f[x].push((null === (d = e.textContent) || void 0 === d ? void 0 : d.charAt(C)) || "");
        }
        (h = f.map(function(e) {
          return $5f3f247996b86434$var$t(e.join(""));
        })).length < 1 || (u ? r.textContent = "" : r.removeChild(e), h.forEach(function(t) {
          var e = document.createElement("span");
          e.classList.add("line-wrapper"), o && $5f3f247996b86434$var$n(e, o), e.style.display = "block", 
          e.style.width = "100%", l && $5f3f247996b86434$var$a(e, l);
          var s = document.createElement("span");
          s.classList.add("line-inner"), i && $5f3f247996b86434$var$n(s, i), s.style.display = "block", 
          s.style.width = "100%", c && $5f3f247996b86434$var$a(s, c), s.innerHTML = t, e.appendChild(s), 
          r.appendChild(e);
        }));
      }(e, o, i, l, c, s);
    });
  }
  function $5f3f247996b86434$var$i(t, o, i, l, c) {
    $5f3f247996b86434$var$e(t), $5f3f247996b86434$var$r(t).forEach(function(e) {
      var r = e.textContent || "", s = t.dataset.originaltext;
      s && (r = s);
      var d = r.match(/\S+|\s+/g);
      d && (s ? t.textContent = "" : t.removeChild(e), d.forEach(function(e) {
        var r = document.createElement("span");
        r.classList.add("word-wrapper"), o && $5f3f247996b86434$var$n(r, o), l && $5f3f247996b86434$var$a(r, l);
        var s = document.createElement("span");
        s.classList.add("word-inner"), i && $5f3f247996b86434$var$n(s, i), c && $5f3f247996b86434$var$a(s, c), 
        s.textContent = e, r.appendChild(s), t.appendChild(r);
      }));
    });
  }
  function $5f3f247996b86434$var$l(t, o, i, l, c) {
    $5f3f247996b86434$var$e(t), $5f3f247996b86434$var$r(t).forEach(function(e) {
      var r = e.textContent || "", s = t.dataset.originaltext;
      s && (r = s);
      var d = r.split("");
      d && (s ? t.textContent = "" : t.removeChild(e), d.forEach(function(e) {
        var r = document.createElement("span");
        r.classList.add("char-wrapper"), o && $5f3f247996b86434$var$n(r, o), l && $5f3f247996b86434$var$a(r, l);
        var s = document.createElement("span");
        s.classList.add("char-inner"), i && $5f3f247996b86434$var$n(s, i), c && $5f3f247996b86434$var$a(s, c), 
        s.textContent = e, r.appendChild(s), t.appendChild(r);
      }));
    });
  }
  $5f3f247996b86434$exports = function(t, e) {
    var n = t;
    "string" == typeof t && (n = document.querySelectorAll(t));
    var a = (null == e ? void 0 : e.type) || "lines", r = function(t, e, n, a, r) {};
    switch (a) {
     case "lines":
      r = $5f3f247996b86434$var$o;
      break;

     case "words":
      r = $5f3f247996b86434$var$i;
      break;

     case "chars":
      r = $5f3f247996b86434$var$l;
    }
    n.forEach(function(t) {
      r(t, null == e ? void 0 : e.wrapperClass, null == e ? void 0 : e.innerClass, null == e ? void 0 : e.wrapperStyle, null == e ? void 0 : e.innerStyle);
    }), (null == e ? void 0 : e.onComplete) && e.onComplete();
  };
  var $3590a52aad0581f1$export$2e2bcd8739ae039 = (0, $parcel$interopDefault($5f3f247996b86434$exports));
  var $3725fe845b33d94a$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("reveal-text")) return;
    customElements.define("reveal-text", class RevealText extends HTMLElement {
      constructor() {
        super();
        this.wrapperClass = "line-wrapper";
        this.innerClass = "line-inner";
        this.opacity = this.dataset.opacity || .3;
        this.start = this.dataset.start || .75;
        this.end = this.dataset.end || .25;
        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.ticking = false;
        this.resizeTimeout = null;
      }
      connectedCallback() {
        if (this.childNodes?.length === 0) return;
        this.content = this.querySelector("[data-reveal-content]") || this.children[0];
        this.contentId = this.content.getAttribute("id");
        this.originalHTML = this.content.innerHTML;
        if (!this.contentId) {
          this.contentId = "reveal-text-".concat(this.closest(".shopify-section")?.getAttribute("id") || Math.random().toString(16).slice(2));
          this.content.setAttribute("id", this.contentId);
        }
        this.init();
      }
      disconnectedCallback() {
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("resize", this.handleResize);
        clearTimeout(this.resizeTimeout);
      }
      init() {
        const currentColor = getComputedStyle(this.content).color.replace("rgb", "rgba");
        const from = currentColor.replace(")", ", 1)");
        const to = currentColor.replace(")", `, ${this.opacity})`);
        (0, $3590a52aad0581f1$export$2e2bcd8739ae039)("#".concat(this.contentId), {
          type: "lines",
          wrapperClass: this.wrapperClass,
          innerClass: this.innerClass,
          onComplete: () => {
            this.lines = this.querySelectorAll(`.${this.wrapperClass}`);
            this.lines.forEach(line => {
              line.style.backgroundImage = `linear-gradient(to right, ${from} 50%, ${to} 50%)`;
              line.style.backgroundSize = "200% 100%";
              line.style.backgroundPositionX = "100%";
              line.style.color = "transparent";
              line.style.backgroundClip = "text";
              line.style.webkitBackgroundClip = "text";
            });
            window.addEventListener("scroll", this.handleScroll, {
              passive: true
            });
            window.addEventListener("resize", this.handleResize);
            this.handleScroll();
          }
        });
      }
      handleScroll() {
        if (!this.lines || this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          const windowHeight = window.innerHeight;
          const rect = this.getBoundingClientRect();
          const startReveal = windowHeight * this.start;
          const endReveal = windowHeight * this.end;
          const range = startReveal - endReveal;
          let totalProgress = (startReveal - rect.top) / range;
          totalProgress = Math.max(0, Math.min(1, totalProgress));
          const totalLines = this.lines.length;
          this.lines.forEach((line, index) => {
            const lineStart = index / totalLines;
            const lineEnd = (index + 1) / totalLines;
            let lineProgress = (totalProgress - lineStart) / (lineEnd - lineStart);
            lineProgress = Math.max(0, Math.min(1, lineProgress));
            const bgPosition = 100 - lineProgress * 100;
            line.style.backgroundPositionX = `${bgPosition}%`;
          });
          this.ticking = false;
        });
      }
      handleResize() {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.reinit();
        }, 150);
      }
      reinit() {
        if (!this.content) return;
        this.content.innerHTML = this.originalHTML;
        this.init();
      }
    });
  })();
})();